/**
 * Pure helpers for hybrid / infinite-scroll DataTable "select all" header state.
 * Prefer derived state over sticky booleans so the header stays correct as rows hydrate.
 */

/**
 * Header "select all" checked state — derived from selection vs current rows (never sticky).
 * Only true when every loaded row is selected and hydration has reached totalCount (when known).
 */
export function deriveHybridSelectAllChecked(
  selectedIds: Iterable<string>,
  rowIds: readonly string[],
  totalCount?: number | null
): boolean {
  if (rowIds.length === 0) return false;
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds);
  if (!rowIds.every((id) => selected.has(id))) return false;
  if (totalCount != null && totalCount > 0 && rowIds.length < totalCount) {
    return false;
  }
  return true;
}

/**
 * Header indeterminate when there is a selection that is not a complete select-all.
 */
export function deriveHybridSelectAllIndeterminate(
  selectedIds: Iterable<string>,
  rowIds: readonly string[],
  totalCount?: number | null
): boolean {
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds);
  if (selected.size === 0) return false;
  return !deriveHybridSelectAllChecked(selected, rowIds, totalCount);
}
